module.exports = __webpack_public_path__ + "img/page8-bg-card.af712f49.svg";